import React, { useState, useEffect } from "react";
import { createChecklist as serviceCreateChecklist } from "../../services/settingsService";
import { useSettingsState } from "../../state/settingsState";
import { Input, Button, Form, Card, notification, Select } from 'antd';

const ChecklistForm = ({ parent = null }) => {
  const { selectedStatus, setChecklists, checklists, getFilteredStatuses } = useSettingsState();
  const allStatuses = getFilteredStatuses();
  const [name, setName] = useState("");
  const [selectedStatuses, setSelectedStatuses] = useState(() => {
    if (parent && Array.isArray(parent.statuses)) {
      return parent.statuses;
    }
    return selectedStatus ? [selectedStatus.amo_status_id] : [];
  });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (parent && Array.isArray(parent.statuses)) {
      setSelectedStatuses(parent.statuses);
    } else if (!parent && selectedStatus?.amo_status_id) {
      setSelectedStatuses([selectedStatus.amo_status_id]);
    }
  }, [parent, selectedStatus]);

  const handleCreateChecklist = async () => {
    if (!name.trim()) return;
    if (!parent && (!selectedStatuses || selectedStatuses.length === 0)) {
      notification.error({
        message: 'Ошибка',
        description: 'Пожалуйста, выберите хотя бы один статус',
        placement: 'bottomRight'
      });
      return;
    }
    
    setLoading(true);
    try {
      const newChecklist = { name, fields_ids: [], statuses: selectedStatuses };
      if (parent) {
        newChecklist.parent = parent.id;
      }
      
      const checklist = await serviceCreateChecklist(selectedStatus.amo_status_id, newChecklist);
      
      if (!checklist || Object.keys(checklist).length === 0) {
        throw new Error('Не удалось создать чеклист');
      }
      
      setChecklists([...checklists, checklist]);
      form.resetFields();
      setName("");
      
      notification.success({
        message: 'Успех',
        description: 'Чеклист успешно создан',
        placement: 'bottomRight'
      });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: 'Не удалось создать чеклист',
        placement: 'bottomRight'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card size="small" title="Создать чеклист">
      <Form form={form} layout="vertical" onFinish={handleCreateChecklist}>
        <Form.Item label="Статусы">
          <Select
            optionLabelProp="children"
            mode="multiple"
            placeholder="Выберите статусы"
            value={selectedStatuses}
            onChange={(values) => {
              const newValues = values.includes(selectedStatus.amo_status_id)
                ? values
                : [...values, selectedStatus.amo_status_id];
              setSelectedStatuses(newValues);
            }}
            disabled={loading || Boolean(parent)}
            style={{ width: '100%' }}
          >
            {allStatuses.map((status) => (
              <Select.Option
                key={status.amo_status_id}
                value={status.amo_status_id}
              >
                {status.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item 
          name="name" 
          rules={[{ required: true, message: 'Пожалуйста, введите название чеклиста' }]}
        >
          <Input 
            placeholder="Название чеклиста" 
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={loading}
          />
        </Form.Item>
        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit"
            loading={loading}
            disabled={!name.trim() || loading}
          >
            Создать чеклист
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ChecklistForm;
